import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
  Input
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import Breadcrumbs from "components/Common/Breadcrumb";
import CustomDatePicker from "common/CustomDatePicker";
import TableContainerColumnTotal from "components/Common/TableContainerColumnTotal";

const SelectcustomStyles = {
  control: (base) => ({ ...base, minHeight: 33.1, height: 33.1 }),
  dropdownIndicator: (base) => ({ ...base, padding: "2px 8px" }),
  clearIndicator: (base) => ({ ...base, padding: "2px 8px" }),
  valueContainer: (base) => ({ ...base, padding: "0px 8px" }),
  input: (base) => ({ ...base, margin: 0, padding: 0 }),
};

const categoryOptions = [
  { label: "Staff", value: "Staff" },
  { label: "Manager", value: "Manager" },
  { label: "Admin", value: "Admin" },
];

const departmentOptions = [
  { label: "QUALITY CONTROL", value: "QUALITY CONTROL" },
  { label: "PRODUCTION", value: "PRODUCTION" },
  { label: "PACKING", value: "PACKING" },
  { label: "CUTTING", value: "CUTTING" },
];

const designationOptions = [
  { label: "Office Assistant", value: "Office Assistant" },
  { label: "Apprentice", value: "Apprentice" },
  { label: "Senior Manager", value: "Senior Manager" },
];

const PayrollReportIndividualPay = () => {
  const formik = useFormik({
    initialValues: {
      category: "",
      department: "",
      designation: "",
      month: "",
      employeeCode: "",
      employeeName: "",
    },
    validationSchema: Yup.object({
      month: Yup.string().required("Month is required"),
    }),
    onSubmit: (values) => {
      console.log("Form Submitted", values);
    },
  });

  const [data] = useState([
    { sno: 1, code: "001", name: "ARUN", gender: "Male", doj: "01.01.24", category: "Staff", designation: "Office Assistant", department: "QUALITY CONTROL", scale: "", shift: "AM", workLocation: "Expat", phone: "9845620000", mobile: "9845620000", totalDays: 30, weekOff: 4, holiday: 1, maxWorkDays: 25, absent: 0, netPaidDays: 30, grossEarningsActual: 17000, basicDA: 11900, hra: 850, conveyance: 3400, washing: 850, fuel: 0, ot: 0, otSalary: 0, travel: 0, grossEarnings: 17000, pensionCont: 991, epfDiff: 437, employerPf: 1428, employerEsi: 497 },
    { sno: 2, code: "002", name: "VIGNESH", gender: "Male", doj: "01.01.24", category: "Staff", designation: "Apprentice", department: "PRODUCTION", scale: "", shift: "AM", workLocation: "Expat", phone: "7010140000", mobile: "7010140000", totalDays: 30, weekOff: 4, holiday: 1, maxWorkDays: 25, absent: 0, netPaidDays: 30, grossEarningsActual: 40100, basicDA: 28070, hra: 2005, conveyance: 8020, washing: 2005, fuel: 0, ot: 0, otSalary: 0, travel: 0, grossEarnings: 40100, pensionCont: 1250, epfDiff: 550, employerPf: 1800, employerEsi: 0 },
    { sno: 3, code: "003", name: "ULAGURAJ", gender: "Male", doj: "01.01.24", category: "Manager", designation: "Senior manager", department: "PACKING", scale: "", shift: "AM", workLocation: "Expat", phone: "7011250000", mobile: "7011250000", totalDays: 30, weekOff: 4, holiday: 1, maxWorkDays: 25, absent: 0, netPaidDays: 30, grossEarningsActual: 20000, basicDA: 14000, hra: 1000, conveyance: 4000, washing: 1000, fuel: 0, ot: 0, otSalary: 0, travel: 0, grossEarnings: 20000, pensionCont: 1166, epfDiff: 514, employerPf: 1680, employerEsi: 585 },
    { sno: 4, code: "005", name: "PARAMESH", gender: "Male", doj: "01.01.24", category: "Staff", designation: "Assistant Engineer", department: "CUTTING", scale: "", shift: "AM", workLocation: "Expat", phone: "7585220000", mobile: "7585220000", totalDays: 30, weekOff: 4, holiday: 1, maxWorkDays: 25, absent: 0, netPaidDays: 30, grossEarningsActual: 41000, basicDA: 28700, hra: 2050, conveyance: 8200, washing: 2050, fuel: 0, ot: 0, otSalary: 0, travel: 0, grossEarnings: 41000, pensionCont: 1250, epfDiff: 550, employerPf: 1800, employerEsi: 0 },
    { sno: 5, code: "006", name: "REVATHY", gender: "Female", doj: "01.02.24", category: "Staff", designation: "Cash officer", department: "Admin", scale: "", shift: "AM", workLocation: "Expat", phone: "9845560000", mobile: "9845560000", totalDays: 30, weekOff: 4, holiday: 1, maxWorkDays: 25, absent: 0, netPaidDays: 30, grossEarningsActual: 22000, basicDA: 15400, hra: 1100, conveyance: 4400, washing: 1100, fuel: 0, ot: 0, otSalary: 0, travel: 0, grossEarnings: 22000, pensionCont: 1250, epfDiff: 550, employerPf: 1800, employerEsi: 644 },
    { sno: 6, code: "007", name: "RAHUL", gender: "Male", doj: "01.03.24", category: "Admin", designation: "Junior Engineer", department: "QUALITY", scale: "", shift: "AM", workLocation: "Expat", phone: "9840000001", mobile: "9840000001", totalDays: 30, weekOff: 4, holiday: 1, maxWorkDays: 25, absent: 0, netPaidDays: 30, grossEarningsActual: 32000, basicDA: 21000, hra: 1200, conveyance: 5000, washing: 1000, fuel: 0, ot: 0, otSalary: 0, travel: 0, grossEarnings: 32000, pensionCont: 1200, epfDiff: 550, employerPf: 1800, employerEsi: 500 },
    { sno: 7, code: "008", name: "MEENA", gender: "Female", doj: "01.03.24", category: "Staff", designation: "Assistant Engineer", department: "STORE", scale: "", shift: "AM", workLocation: "Expat", phone: "9840000002", mobile: "9840000002", totalDays: 30, weekOff: 4, holiday: 1, maxWorkDays: 25, absent: 0, netPaidDays: 30, grossEarningsActual: 28000, basicDA: 20000, hra: 1000, conveyance: 4000, washing: 1000, fuel: 0, ot: 0, otSalary: 0, travel: 0, grossEarnings: 28000, pensionCont: 1100, epfDiff: 550, employerPf: 1800, employerEsi: 450 },
    { sno: 8, code: "009", name: "KARTHIK", gender: "Male", doj: "01.03.24", category: "Manager", designation: "Senior manager", department: "CIVIL", scale: "", shift: "AM", workLocation: "Expat", phone: "9840000003", mobile: "9840000003", totalDays: 30, weekOff: 0, holiday: 1, maxWorkDays: 29, absent: 0, netPaidDays: 30, grossEarningsActual: 82156, basicDA: 57509, hra: 4108, conveyance: 16431, washing: 4108, fuel: 0, ot: 0, otSalary: 0, travel: 0, grossEarnings: 82156, pensionCont: 1250, epfDiff: 550, employerPf: 1800, employerEsi: 0 },
    { sno: 9, code: "010", name: "LATHA", gender: "Female", doj: "01.03.24", category: "Staff", designation: "Assistant Engineer", department: "CUTTING", scale: "", shift: "AM", workLocation: "Expat", phone: "9840000004", mobile: "9840000004", totalDays: 30, weekOff: 4, holiday: 1, maxWorkDays: 25, absent: 0, netPaidDays: 30, grossEarningsActual: 30000, basicDA: 21000, hra: 1500, conveyance: 6000, washing: 1500, fuel: 0, ot: 0, otSalary: 0, travel: 0, grossEarnings: 30000, pensionCont: 1250, epfDiff: 550, employerPf: 1800, employerEsi: 400 },
    { sno: 10, code: "011", name: "SURESH", gender: "Male", doj: "01.03.24", category: "Manager", designation: "Apprentice", department: "Admin", scale: "", shift: "AM", workLocation: "Expat", phone: "9840000005", mobile: "9840000005", totalDays: 30, weekOff: 4, holiday: 1, maxWorkDays: 25, absent: 0, netPaidDays: 30, grossEarningsActual: 50000, basicDA: 35000, hra: 3000, conveyance: 8000, washing: 2000, fuel: 0, ot: 0, otSalary: 0, travel: 0, grossEarnings: 50000, pensionCont: 1250, epfDiff: 550, employerPf: 1800, employerEsi: 480 },
    { sno: 11, code: "012", name: "DEEPA", gender: "Female", doj: "01.03.24", category: "Staff", designation: "Apprentice", department: "ANCILLARY", scale: "", shift: "AM", workLocation: "Expat", phone: "9840000006", mobile: "9840000006", totalDays: 30, weekOff: 4, holiday: 1, maxWorkDays: 25, absent: 0, netPaidDays: 30, grossEarningsActual: 52000, basicDA: 36400, hra: 2600, conveyance: 10400, washing: 2600, fuel: 0, ot: 0, otSalary: 0, travel: 0, grossEarnings: 52000, pensionCont: 1250, epfDiff: 550, employerPf: 1800, employerEsi: 510 },
    { sno: 12, code: "013", name: "VIJAY", gender: "Male", doj: "01.03.24", category: "Staff", designation: "Junior Engineer", department: "PRODUCTION", scale: "", shift: "AM", workLocation: "Expat", phone: "9840000007", mobile: "9840000007", totalDays: 30, weekOff: 4, holiday: 1, maxWorkDays: 25, absent: 0, netPaidDays: 30, grossEarningsActual: 22000, basicDA: 15400, hra: 1100, conveyance: 4400, washing: 1100, fuel: 0, ot: 0, otSalary: 0, travel: 0, grossEarnings: 22000, pensionCont: 1250, epfDiff: 550, employerPf: 1800, employerEsi: 420 },
    { sno: 13, code: "014", name: "SANDHYA", gender: "Female", doj: "01.03.24", category: "Admin", designation: "Apprentice", department: "ANCILLARY", scale: "", shift: "AM", workLocation: "Expat", phone: "9840000008", mobile: "9840000008", totalDays: 30, weekOff: 4, holiday: 1, maxWorkDays: 25, absent: 0, netPaidDays: 30, grossEarningsActual: 60000, basicDA: 42000, hra: 3000, conveyance: 9000, washing: 3000, fuel: 0, ot: 0, otSalary: 0, travel: 0, grossEarnings: 60000, pensionCont: 1250, epfDiff: 550, employerPf: 1800, employerEsi: 600 },
    { sno: 14, code: "015", name: "KUMAR", gender: "Male", doj: "01.03.24", category: "Manager", designation: "Senior manager", department: "EMBROIDERY", scale: "", shift: "AM", workLocation: "Expat", phone: "9840000009", mobile: "9840000009", totalDays: 30, weekOff: 4, holiday: 1, maxWorkDays: 25, absent: 0, netPaidDays: 30, grossEarningsActual: 71000, basicDA: 49700, hra: 3550, conveyance: 14200, washing: 3550, fuel: 0, ot: 0, otSalary: 0, travel: 0, grossEarnings: 71000, pensionCont: 1250, epfDiff: 550, employerPf: 1800, employerEsi: 630 },
    { sno: 15, code: "016", name: "PRAVEEN", gender: "Male", doj: "01.03.24", category: "Staff", designation: "Production Supervisor", department: "CUTTING", scale: "", shift: "AM", workLocation: "Expat", phone: "9840000010", mobile: "9840000010", totalDays: 30, weekOff: 4, holiday: 1, maxWorkDays: 25, absent: 0, netPaidDays: 30, grossEarningsActual: 29000, basicDA: 20300, hra: 1450, conveyance: 5800, washing: 1450, fuel: 0, ot: 0, otSalary: 0, travel: 0, grossEarnings: 29000, pensionCont: 1250, epfDiff: 550, employerPf: 1800, employerEsi: 390 }
  ]);

  const columns = [
    { Header: "S.No", Cell: ({ row }) => data.length - row.index, className: "serial-no", applyHeaderClass: true },
    { Header: "Code", accessor: "code" },
    { Header: "Name", accessor: "name" },
    { Header: "Gender", accessor: "gender" },
    { Header: "DOJ", accessor: "doj" },
    { Header: "Category", accessor: "category" },
    { Header: "Designation", accessor: "designation" },
    { Header: "Department", accessor: "department" },
    { Header: "Scale", accessor: "scale" },
    { Header: "Shift", accessor: "shift" },
    { Header: "Work Location", accessor: "workLocation" },
    { Header: "Phone", accessor: "phone" },
    { Header: "Mobile", accessor: "mobile" },
    { Header: "Total Days", accessor: "totalDays", sum: true },
    { Header: "Week Off", accessor: "weekOff", sum: true },
    { Header: "Holiday", accessor: "holiday", sum: true },
    { Header: "Max Work Days", accessor: "maxWorkDays", sum: true },
    { Header: "Abs", accessor: "absent", sum: true },
    { Header: "Net Paid Days", accessor: "netPaidDays", sum: true },
    { Header: "Gross Earnings (Actual)", accessor: "grossEarningsActual", sum: true },
    { Header: "(BASIC + DA)", accessor: "basicDA", sum: true },
    { Header: "HRA", accessor: "hra", sum: true },
    { Header: "CONVEYANCE", accessor: "conveyance", sum: true },
    { Header: "WASHING", accessor: "washing", sum: true },
    { Header: "Fuel", accessor: "fuel", sum: true },
    { Header: "OT", accessor: "ot", sum: true },
    { Header: "OT Salary", accessor: "otSalary", sum: true },
    { Header: "Travel", accessor: "travel", sum: true },
    { Header: "Gross Earnings", accessor: "grossEarnings", sum: true },
    { Header: "PENSION CONT", accessor: "pensionCont", sum: true },
    { Header: "EPF DIFF", accessor: "epfDiff", sum: true },
    { Header: "TOTAL EMPLOYERS PF CONT", accessor: "employerPf", sum: true },
    { Header: "TOTAL EMPLOYERS ESI CONT", accessor: "employerEsi", sum: true },
  ];


  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Payroll" breadcrumbItem="Individual Pay Register" />

        <Card>
          <CardBody>
            <form onSubmit={formik.handleSubmit}>
              <Row className="gy-3">

                <Col md={4}>
                  <Label>Category</Label>
                  <Select
                    styles={SelectcustomStyles}
                    options={categoryOptions}
                    name="category"
                    value={categoryOptions.find(opt => opt.value === formik.values.category) || null}
                    onChange={selected => formik.setFieldValue("category", selected ? selected.value : "")}
                    placeholder="--Select--"
                  />
                </Col>
                <Col md={4}>
                  <Label>Department</Label>
                  <Select
                    styles={SelectcustomStyles}
                    options={departmentOptions}
                    name="department"
                    value={departmentOptions.find(opt => opt.value === formik.values.department) || null}
                    onChange={selected => formik.setFieldValue("department", selected ? selected.value : "")}
                    placeholder="--Select--"
                  />
                </Col>
                <Col md={4}>
                  <Label>Designation</Label>
                  <Select
                    styles={SelectcustomStyles}
                    options={designationOptions}
                    name="designation"
                    value={designationOptions.find(opt => opt.value === formik.values.designation) || null}
                    onChange={selected => formik.setFieldValue("designation", selected ? selected.value : "")}
                    placeholder="--Select--"
                  />
                </Col>
                <Col md={4}>
                  <Label>Employee Code</Label>
                  <Input
                    type="text"
                    name="employeeCode"
                    value={formik.values.employeeCode}
                    onChange={formik.handleChange}
                  />
                </Col>
                <Col md={4}>
                  <Label>Employee Name</Label>
                  <Input
                    type="text"
                    name="employeeName"
                    value={formik.values.employeeName}
                    onChange={formik.handleChange}
                  />
                </Col>
                <Col md={4}>
                  <Label>Month <span className="text-danger">*</span></Label>
                  <CustomDatePicker
                    name="month"
                    value={formik.values.month}
                    onChange={val => formik.setFieldValue("month", val)}
                    onBlur={() => formik.setFieldTouched("month", true)}
                  />
                  {formik.touched.month && formik.errors.month && (
                    <div className="text-danger mt-1">{formik.errors.month}</div>
                  )}
                </Col>
                <Col md={12} className="text-end"> 
                  <Button type="submit" className="btn button-search me-2">
                    <i className="fas fa-search me-1" /> Search
                  </Button>
                  <Button type="button" className="btn button-export me-2">
                    <i className="fas fa-file-export me-1" /> Export
                  </Button>
                  <Button type="reset" onClick={formik.handleReset} className="btn button-cancel ">
                    <i className="fas fa-sync me-1" /> Cancel
                  </Button>
                </Col>
              </Row>
            </form>
          </CardBody>
        </Card>

        <Card>
          <CardBody>
            <TableContainerColumnTotal
              columns={columns}
              data={data}
              isGlobalFilter={true}
              customPageSize={10}
            />
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default PayrollReportIndividualPay;
